import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { BreadcrumbItem } from './index'
import Blink from '@components/Blink'

const commonItemStyle = css`
  position: relative;
  text-align: center;
  overflow: hidden;
`

const StyledItem = styled(Blink)`
  ${({
    theme: {
      colors: { textWeak },
      typography: {
        subheads: {
          small2: { bundledCSS: small2SubheadCSS },
        },
      },
    },
  }) => css`
    ${commonItemStyle};
    ${small2SubheadCSS};
    text-decoration: none;
    color: ${textWeak};
  `}
`

const StyledLastItem = styled.span`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadCSS },
        },
      },
    },
  }) => css`
    ${commonItemStyle};
    ${small1SubheadCSS};
    color: ${textDefault};
    margin: 0;
  `}
`

const Item: FunctionComponent<BreadcrumbItem> = ({ title, link, isLast }) => {
  if (isLast || !link) {
    return <StyledLastItem>{title}</StyledLastItem>
  }

  return <StyledItem {...link}>{title}</StyledItem>
}

export default Item
